module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.nextPant && (_vm.screenTrack[0] < _vm.screenTrack[1])) ? _c('router-link', {
    staticClass: "rout-bot bot-right hvr-grow",
    attrs: {
      "id": "nav-adel-bot",
      "aria-label": "Página siguiente",
      "to": _vm.linksPath + (_vm.screenTrack[0] + 1)
    },
    nativeOn: {
      "click": function($event) {
        _vm.guardarubicacion()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7546aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/NavAdel.vue
// module id = 1030
// module chunks = 1